import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import AccountMenu from './AccountMenu';
import HeaderCategories from './HeaderCategories';
import MobileMenu from './MobileMenu';
import SearchBox from './SearchBox';
import './HomeHeader.css';

// Site header: logo left, optional compact search center, account right. Not
// sticky. Rendered once for every route by App's SiteHeader, so every page shows
// either the Log In button or the signed-in account pill; the homepage omits the
// search (it has the hero search). `showCategories` puts the category icons
// next to the logo (every page but the homepage and checkout, set by App).
// On mobile a hamburger left of the logo opens the full-screen MobileMenu, and
// only Log In shows on the right.
const HomeHeader = ({ showSearch = false, showCategories = false }) => {
    const { isLoggedIn, openLogin, openSignup } = useAuth();
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="gh-header-bar">
        <header className="gh-header">
            <button
                type="button"
                className="gh-header-menu"
                aria-label="Open menu"
                aria-expanded={menuOpen}
                onClick={() => setMenuOpen(true)}
            >
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                    <line x1="5" y1="7" x2="19" y2="7" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <line x1="5" y1="17" x2="19" y2="17" />
                </svg>
            </button>

            <Link to="/" className="gh-header-logo">Gradies</Link>

            {showCategories && <HeaderCategories />}

            {showSearch && (
                <div className="gh-header-search">
                    <SearchBox
                        variant="header"
                        source="header"
                        placeholder="Search by card name"
                    />
                </div>
            )}

            <div className="gh-header-auth">
                {isLoggedIn ? (
                    <AccountMenu />
                ) : (
                    <>
                        <button type="button" className="gh-header-signup" onClick={openSignup}>
                            Sign Up
                        </button>
                        <button type="button" className="gh-header-login" onClick={openLogin}>
                            Log In
                        </button>
                    </>
                )}
            </div>
        </header>
        {menuOpen && <MobileMenu onClose={() => setMenuOpen(false)} />}
        </div>
    );
};

export default HomeHeader;
